export class Cepage {
    static jsonMap = {
        id: 'id',
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    id: number = undefined;
    libelle: string = undefined;
}
